<template>
  <div>
    <Modal v-model="modal" :title="lang=='zh'?chName.savetDraft:enName.savetDraft" width="460">
      <div class="center" style="padding: 0 20px">
        <Form :label-width="150" label-position="left" @submit.native.prevent>
          <Row>
            <Col span="24">
              <FormItem :label="lang=='zh'?chName.draftName:enName.draftName">
                <Input v-model="formItem.draftName" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer">
        <Button class="applyButtonLeft" @click="comf">{{lang=='zh'?chName.confirm:enName.confirm}}</Button>
        <Button class="applyButtonLeft" @click="modal = false">{{lang=='zh'?chName.cancel:enName.cancel}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      formItem: {},
      modal: false,
      prevent: false,
      draftType: "",
      draftContent: "",
      chName:{},
      enName:{},
    };
  },
  computed: {
    //国际化监听
    lang(){
      return this.$store.getters.selectLangeData
    },
  },
  methods: {
    getInternation(){
      let Obj = {
          viewType:"Common",
          beUsed : "1"
      } 
      axios.post('/International/applySelectViewSet',Obj).then((res) => {
        console.log(res)     
          this.chName= res.data[0]
          this.enName= res.data[1]
        })
    },
    popShow(draftType, draftContent) {
      this.modal = true;
      this.draftType = draftType;
      this.draftContent = JSON.stringify(draftContent);
    },
    handleSubmit(draftType, draftContent) {
      this.draftType = draftType;
      this.draftContent = JSON.stringify(draftContent);
      let objData = {
        draftContent: this.draftContent,
        draftCreator: JSON.parse(sessionStorage.getItem("userInfo")).userName,
        draftName: this.formItem.draftName,
        draftType: this.draftType,
        createUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        updateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      }
      axios.post("/Draft/insertDraftData", objData).then((res) => {
        this.prevent = false;
        if (res) {
          this.$Message.success(this.$t('Save_Successful'));
          this.modal = false;
          this.$emit("spinShow")
        }
      });
    },
    comf() {
      this.$Modal.confirm({
        title: this.$notice('sureSave'),
        content: "",
        onOk: () => {
          this.prevent = true;
          this.handleSubmit();
        },
        onCancel: () => {},
      });
    },
  },
};
</script>
<style>
.applyButtonLeft {
  color: white;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/component/DraftPop.vue